import { resourceTypes, resourceTypeKeys, type ResourceTypeKey, type ResourceType } from './resourceFilterInterface';

export type ResourceStatusKey = (typeof resourceStatusKeys)[keyof typeof resourceStatusKeys];

export const resourceStatusKeys = {
	Todo: 'todo',
	Completed: 'completed',
} as const;

// TODO
// Find a better way of doing this...
const resourceTypesToUse = { ...resourceTypes };
// @ts-expect-error Need a better way of doing this...
delete resourceTypesToUse[resourceTypeKeys.Bot];

export const getResourceByStatuses = (): ResourcesByStatuses => {
	return {
		[resourceStatusKeys.Todo]: {
			key: resourceStatusKeys.Todo,
			name: 'Todo',
			// We could use structuredClone here, but it's not supported in all browsers yet and we have
			// had some issues with users on older Safari versions. The data here isn't complicated so
			// JSON methods should be fine.
			resourcesByType: JSON.parse(JSON.stringify(resourceTypesToUse)),
		},
		[resourceStatusKeys.Completed]: {
			key: resourceStatusKeys.Completed,
			name: 'Completed',
			resourcesByType: JSON.parse(JSON.stringify(resourceTypesToUse)),
		},
	};
};

export type ResourcesByStatuses = {
	[key in ResourceStatusKey]: {
		key: ResourceStatusKey;
		name: string;
		resourcesByType: {
			[key in ResourceTypeKey]: ResourceType;
		};
	};
};
